import axios from 'axios';
import { REST_HOSTNAME } from '../Config';
import { IUser } from './UserApi';

const axiosInstance = axios.create({
    baseURL: REST_HOSTNAME
});

// Add request interceptor
axiosInstance.interceptors.request.use(
    function (config) {
        const jwt = localStorage.getItem('jwt');
        if (jwt) {
            config.headers['x-access-token'] = jwt; // Add JWT to the headers
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export const UserAdminApi = {
    search: function (firstName?: string, lastName?: string, email?: string) {
        return axiosInstance.request<IUser[]>({
            method: 'GET',
            url: `/user_admin/search`,
            params: {
                first_name: firstName,
                last_name: lastName,
                email: email,
            },
        });
    },
    changePassword: function (userId: number, password: string) {
        return axiosInstance.request<IUser[]>({
            method: 'PUT',
            url: `/user_admin/password/${userId}`,
            data: {
                password: password,
            },
        });
    },
    delete: function (userId: number) {
        return axiosInstance.request<IUser[]>({
            method: 'DELETE',
            url: `/user_admin/${userId}`,
        });
    }
}
